export default __webpack_public_path__ + "static/media/L_Leao.021f73ad.svg";